<template>
  <app-modal :modal-id="modalId" :title="modalTitle" :preloader="preloader"
                @submit="submit" @close-modal="closeModal" 
                modal-size="large" modal-alignment="center">
        <template slot="header">
            <h5 class="modal-title" id="ModalLabel">{{ modalTitle }}</h5>
            <button type="button" class="close outline-none" @click.prevent="closeModal">
                <span>
                    <app-icon :name="'x'"></app-icon>
                </span>
            </button>
        </template>
        <template slot="body">
            <app-overlay-loader v-if="preloader" />
            <form class="mb-0" :class="{ 'loading-opacity': preloader }" ref="form"
                :data-url='selectedUrl ? `payroll-periods/${inputs.id}` : `payroll-periods`'>
                <div class="row">
                    <div class="col-md-12">
                        <!-- Name Input -->
                        <div class="form-group">
                            <label for="name">{{ $t('name') }}</label>
                            <app-input id="name" type="text" v-model="inputs.name"
                                :placeholder="$t('name')"/>
                        </div>
                    </div>
                    <div class="col-md-12">
                        <app-form-group
                            :label="$t('start_date')"
                            type="date"
                            v-model="inputs.start_date"
                            :placeholder="$t('start_date')"
                            :required="true"
                        />
                    </div>
                    <div class="col-md-12">
                        <app-form-group
                            :label="$t('end_date')"
                            type="date"
                            v-model="inputs.end_date"
                            :placeholder="$t('end_date')"
                        />
                    </div>
                </div>
            </form>
        </template>
        <template slot="footer">
            <button type="button" class="btn btn-secondary mr-2" data-dismiss="modal" @click="closeModal">
                {{ $t('cancel') }}
            </button>
            <button type="button" class="btn btn-primary" @click="submit">{{ $t('save') }}</button>
        </template>
    </app-modal>
</template>

<script>
import {formatDateForServer} from "../../../../common/Helper/Support/DateTimeHelper";
import { FormMixin } from '../../../../core/mixins/form/FormMixin';
import { ModalMixin } from '../../../Mixins/ModalMixin';

export default {
    name: 'PayrollPeriodAddEditModal',
    mixins: [FormMixin, ModalMixin],
    props: {
        tableId: {
            type: String,
        },
    },
    computed: {

    },
    data() {
        return {
            preloader: false,
            modalId: 'payroll-period-add-edit-modal',
            inputs: {
                name: '',
                status: '',
                start_date: '',
                end_date: '',
            },
            statusOptions: [
                { value: 'active', text: this.$t('active') },
                { value: 'inactive', text: this.$t('inactive') },
            ],
            isModalActive: false,
            modalTitle: `${this.$t('new-payroll-period')}`,
        }
    },
    methods: {
        submit() {
            let formData = this.inputs;

            formData.start_date = formatDateForServer(formData.start_date);
            formData.end_date = formatDateForServer(formData.end_date);

            this.save(formData);
            this.$hub.$emit('reload-' + this.tableId);
        },

        afterSuccess(response) {
            this.$toastr.s(response.data.message);
            this.$hub.$emit('reload-' + this.tableId);
        },

        afterSuccessFromGetEditData({ data }) {
            this.inputs = data;
            this.inputs.start_date = data.start_date ? new Date(data.start_date) : '';
            this.inputs.end_date = data.end_date ? new Date(data.end_date) : '';
            this.preloader = false;
        },
    },
    created() {
        if (this.selectedUrl) {
            this.modalTitle = this.$t('edit');
            this.preloader = true;
        }
    },
}
</script>

<style>

</style>